import React, { Component } from "react";

/**
 * Component that alerts if you click outside of it
 */
export default class OutsideClickNotifier extends Component {
  constructor(props) {
    super(props);

    this.setWrapperRef = this.setWrapperRef.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutsideHandler.bind(this));
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutsideHandler.bind(this));
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutsideHandler(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
        this.props.handler(event);
    }
  }

  render() {
    return <div ref={this.setWrapperRef}>{this.props.children}</div>;
  }
}